// Firebase Web SDK config + initialization.
//
// A apiKey publica nao e segredo — vai inevitavelmente pro JS bundle do
// cliente. Seguranca esta em:
//   1. Firebase Auth Authorized Domains (truco-top-next.surge.sh,
//      truco-top.surge.sh, localhost — configurado no Console)
//   2. Firestore Security Rules
//   3. Cloud Run IAM
//
// Config gerada via Firebase Management API em 2026-05-19 pro web app
// "truco-top-web" no projeto truco-top.

import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyDFQ4iSPbYRPAc0RJn4QzaxrLgWRRIfLPw',
  authDomain: 'truco-top.firebaseapp.com',
  projectId: 'truco-top',
  storageBucket: 'truco-top.firebasestorage.app',
  messagingSenderId: '317142720154',
  appId: '1:317142720154:web:6771c7b172e85f65084923',
};

export const firebaseApp = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);

// browserLocalPersistence: token sobrevive refresh + fechamento do tab.
// Firebase SDK gerencia refresh do ID token automaticamente (expira em 1h,
// renova proativamente). Sem precisar de logica nossa pra renovar.
setPersistence(firebaseAuth, browserLocalPersistence).catch((err) => {
  console.warn('firebase: setPersistence falhou —', err);
});
